export default __webpack_public_path__ + "static/media/profileImage.a262e490.png";